import React from 'react'

const accuracyBarColors = {
  English: '#4E57EF',
  Math: '#DE3C7D',
  Reading: '#F36F4A',
  Science: '#3BBC4C',
  'R&W 1': '#4E57EF',
  'R&W 2': '#4E57EF',
  'Math 1': '#DE3C7D',
  'Math 2': '#DE3C7D',
}

const getBarWidth = (percentString) => {
  const percent = parseFloat(percentString)
  if (isNaN(percent)) return '0%'
  return `${percent}%`
}

const AccuracyChart = ({ accuracyData }) => (
  <div className="w-full flex flex-col gap-6 mt-8">
    <div className="text-[#030303] text-lg font-bold leading-[1.2] mb-2">
      Accuracy
    </div>
    <div className="flex flex-col gap-6 max-w-[900px]">
      {Object.keys(accuracyData).map((subject) => (
        <div
          key={subject}
          className="flex w-full items-center gap-[40px] flex-wrap rounded-[999px]"
        >
          <div
            className="text-[#030303] text-sm font-medium leading-[1.2] min-w-[80px]"
            style={{ width: 90 }}
          >
            {subject}
          </div>
          <div className="flex items-center gap-4 flex-1">
            <div className="relative flex-1 h-2 bg-[#F0F0F0] rounded-full overflow-hidden">
              <div
                className="absolute top-0 left-0 h-2 rounded-full"
                style={{
                  width: getBarWidth(accuracyData[subject]),
                  background: accuracyBarColors[subject] || '#4E57EF',
                  transition: 'width 0.5s',
                }}
              />
            </div>
            <div className="text-[#030303] text-right text-sm font-medium leading-[1.2] min-w-[60px]">
              {accuracyData[subject]}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)

export default AccuracyChart
